export const TAP_IM_CLOSE_TRANSLATION_ID = 'tapImClose';
export const TAP_IM_CLOSE_CASH_PAYMENT_TRANSLATION_ID = 'tapImCloseCashPayment';
export const APPROX_MINUTES_AWAY_TRANSLATION_ID = 'approxMinutesAway';
